import { Api } from "./Api";

export default {
    index() {
        return Api.get(`/v1/management/clusters`);
    },
    show(cluster_id) {
        return Api.get(`/v1/management/clusters/${cluster_id}`);
    },
    store(obj) {
        return Api.post(`/v1/management/clusters`, obj);
    },
    update(cluster_id, obj) {
        return Api.put(`/v1/management/clusters/${cluster_id}`, obj);
    },
    delete(cluster_id) {
        return Api.delete(`/v1/management/clusters/${cluster_id}`);
    },
}